export default "__VITE_ASSET__oRD6uPdw__"